export default __webpack_public_path__ + "assets/ab98ba.png";